import { ReactElement, useEffect, useState } from 'react'
import {
  Checkbox,
  ICheckboxClickHandler,
} from '../../../ui-components/forms/Checkbox'
import styled from 'styled-components'

interface ListItem {
  value: string | number
  label: string
  id?: number
  active: boolean
  disabled?: boolean
}
export type List = Array<ListItem>

interface CheckboxListProps {
  list?: List
  onChange: (list: List) => void
  selectAll?: boolean
  allAreSelected?: boolean
  fillData?: List
  isCheckMixed?: boolean
  groupId?: number | string
}

export const CheckboxList = (props: CheckboxListProps): ReactElement => {
  const {
    list,
    onChange,
    selectAll = false,
    allAreSelected = false,
    isCheckMixed = false,
    fillData = [],
    groupId = '',
  } = props
  const [items, setItems] = useState(
    (list || []).map((item) => ({ ...item, groupId }))
  )

  useEffect(() => {
    setItems((list || []).map((item) => ({ ...item, groupId })))
  }, [groupId, list])

  const [filled, setFilled] = useState(false)

  const handleItemClick = (value: ICheckboxClickHandler) => {
    const newItems = items
    const index = newItems.findIndex((item) => item.value === value.value)
    newItems[index].active = value.isChecked
    setItems(newItems)
    onChange(newItems)
  }

  useEffect(() => {
    function checkIsActive(item: ListItem) {
      let isActive = false
      fillData?.forEach((fillItem) => {
        if (item.value === fillItem.id) {
          isActive = true
        }
      })
      return isActive
    }
    if ((fillData || []).length > 0 && !filled) {
      setItems((state) => {
        const array = state.map((item) => {
          return { ...item, active: checkIsActive(item) }
        })
        setFilled(true)
        return array
      })
    }
  }, [fillData, onChange, filled, setFilled, items])

  useEffect(() => {
    if (!selectAll && !fillData) {
      setItems((state) => state.map((item) => ({ ...item, active: false })))
    }
  }, [selectAll, fillData])

  useEffect(() => {
    if (allAreSelected && !fillData) {
      setItems((state) => state.map((item) => ({ ...item, active: true })))
    }
  }, [allAreSelected, fillData])

  useEffect(() => {
    if (!isCheckMixed && !allAreSelected && !fillData) {
      setItems((state) => state.map((item) => ({ ...item, active: false })))
    }
  }, [isCheckMixed, allAreSelected, fillData])
  return (
    <Wrapper>
      {items.map((item) => (
        <ItemWrapper key={item.value}>
          <Checkbox
            value={item.value}
            groupId={groupId}
            label={item.label}
            active={item.active}
            onClick={(value) => handleItemClick(value)}
            disabled={item.disabled || false}
          />
        </ItemWrapper>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`

const ItemWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
`
